import { render } from "./EditEventModal.vue?vue&type=template&id=5581a6eb&scoped=true"
import script from "./EditEventModal.vue?vue&type=script&lang=js"
export * from "./EditEventModal.vue?vue&type=script&lang=js"

import "./EditEventModal.vue?vue&type=style&index=0&id=5581a6eb&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5581a6eb"]])

export default __exports__